<template>
  <HeaderSection :currentLang="currentLang" />
  <SectionLogos />
  <AboutSection :currentLang="currentLang" />
  
  <!-- <PromoSection :currentLang="currentLang" /> -->
  <WorkSection :currentLang="currentLang" />
  <StatsSection :currentLang="currentLang" />
  <!-- <TeamSection :currentLang="currentLang" /> -->
  <!-- <SkillsSection :currentLang="currentLang" /> -->
  <ContactSection :currentLang="currentLang" />
  <FooterSection :currentLang="currentLang" />
</template>

<script>
import HeaderSection from '../components/Header.vue'
import SectionLogos from '../components/SectionLogos.vue'
import AboutSection from '../components/About.vue'
// import PromoSection from '../components/Promo.vue'
// import TeamSection from '../components/Team.vue'
import StatsSection from '../components/Stats.vue'
import WorkSection from '../components/Work.vue'
// import SkillsSection from '../components/Skills.vue'
import ContactSection from '../components/Contact.vue'
import FooterSection from '../components/Footer.vue'

export default {
  name: 'HomePage',
  props: {
    currentLang: String
  },
  components: {
    HeaderSection,
    SectionLogos,
    AboutSection,
    // PromoSection,
    // TeamSection,
    StatsSection,
    WorkSection,
    // SkillsSection,
    ContactSection,
    FooterSection
  }
}
</script>